import React from 'react';
import { Paper } from '@mui/material';
import ShoppingCart from 'components/ShoppingCart';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Shopper, OrderProduct, ProductApi } from 'common/types';
import ConfirmBtns from './ConfirmBtns';

interface Props {
	activeShopperId: string;
	setActiveShopperId: (id: string) => void;
	validateRentalAndGoToRoute: (route: string) => void;
	shoppers: Shopper[];
	rentalProducts: OrderProduct[];
	stockProducts: ProductApi[];
	overbookedProducts?: OrderProduct[];
}
const NewRentalSideBar = (props: Props) => {
	const {
		activeShopperId,
		setActiveShopperId,
		rentalProducts,
		shoppers,
		validateRentalAndGoToRoute,
		stockProducts,
		overbookedProducts,
	} = props;
	const classes = useStyles();

	return (
		<Paper
			data-intercom-target="Shopping cart"
			square
			elevation={2}
			className={classes.sideBarCart}
		>
			<div className={classes.sideBarCartScrollable}>
				<ShoppingCart
					activeShopperId={activeShopperId}
					changeActiveShopperId={setActiveShopperId}
					stockProducts={stockProducts}
				/>
			</div>
			<div className={classes.sideBarCartBottom}>
				<ConfirmBtns
					rentalProducts={rentalProducts}
					shoppers={shoppers}
					validateRentalAndGoToRoute={(route: string) => validateRentalAndGoToRoute(route)}
					hasOverbooking={!!overbookedProducts?.length}
				/>
			</div>
		</Paper>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		sideBarCart: {
			flex: '1 0 25%',
			maxWidth: 300,
			minWidth: 250,
			backgroundColor: theme.palette.background.paper,
			zIndex: 2,
			position: 'relative',
			display: 'flex',
			flexDirection: 'column',
		},
		sideBarCartScrollable: {
			flex: 1,
			display: 'flex',
			height: 'calc(100vh - 56px - 32px - 128px)', // Height of header bar and status bar
			[theme.breakpoints.up('sm')]: {
				height: 'calc(100vh - 64px - 32px - 128px)', // Height of header bar and status bar
			},
		},
		sideBarCartBottom: {
			padding: theme.spacing(2),
		},
	}),
);

export default NewRentalSideBar;
